import {makeAutoObservable} from 'mobx';
import {toast} from 'react-toastify';
import LikesRepository from '../../../../../data/repositories/LikesRepository';
import GradebookRepository from '../../../../../data/repositories/GradebookRepository';
import {MicroreelLikes} from '../../../../../data/models/Likes/LikeModel';
import {GradebookLesson} from '../../../../../data/models/Course/Gradebook';
import {getErrorFromCode} from '../../../../../data/errorCodes';
import {toastConfig} from '../../../../../uiToolkit/Toast/toastConfig';

class CourseAnalyticsLikesStore {
  private likesRepo = new LikesRepository();
  private gradebookRepo = new GradebookRepository();

  constructor() {
    makeAutoObservable(this);
  }

  public async getLikes(lessons: GradebookLesson[]): Promise<MicroreelLikes[]> {
    const results = await Promise.all(
      lessons.map(lesson => this.likesRepo.getEntityLikes(lesson.lessonId)),
    );

    const failed = results.find(result => !result.success);
    if (failed) {
      toast.error(getErrorFromCode(failed.errors![0]), toastConfig);
      return [];
    }

    return lessons.map((lesson, index) => ({
      lessonId: lesson.lessonId,
      title: lesson.title,
      poster: lesson.poster,
      totalLikes: results[index].data?.totalLikes || 0,
    }));
  }

  public async getCourseMicroreels(organizationId: string, courseId: string) {
    const result = await this.gradebookRepo.getCourseGradebook(
      organizationId,
      courseId,
    );
    if (result.success && result.data) {
      return [...result.data.lessons].sort(
        (x, y) => x.folderOrder - y.folderOrder || x.order - y.order,
      );
    }
    return [];
  }
}

export default CourseAnalyticsLikesStore;
